module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"shipping":"Valor do frete","optional":"opcional","title":"Envio dos itens"},"en-US":{"shipping":"Shipping value","optional":"optional","title":"Order submission"}}')
  delete Component.options._Ctor
}
